import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { AuthService } from '../../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, catchError, of } from 'rxjs';
import { NavMenuService } from '../../../../../core/components/navmenu/navmenu.service';
import { ListaDatosCaPeriodoViewModel } from '../datosca.types';
import { PeriodoDatosCaService } from '../datosca.service';

@Component({
    selector: 'app-datosca-wrapper',
    templateUrl: './datosca-wrapper.component.html',
})
export class DatosCaWrapperComponent extends ComponentBase implements OnInit {
    searching = false;
    listaDatosCaPeriodo: ListaDatosCaPeriodoViewModel;

    private periodoId = 0;
    private route = '/mantenimiento/periodos/listadatosca';

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.periodoId = parseInt(id);
            this.getListaDatosCa();
        } else {
            console.error('Parámetro Id inexistente en la ruta');
        }
    });

    constructor(
        private activatedRoute: ActivatedRoute,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private datosCaService: PeriodoDatosCaService,
        private navMenuService: NavMenuService,
        private router: Router,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        // no-op
    }

    /**
     * It will send the filter to the backend and set the response.
     * @return void
     */
    private getListaDatosCa(): void {
        if (!this.periodoId) {
            return;
        }
        this.datosCaService
            .getListaDatosCaPeriodo(this.periodoId)
            .pipe(
                tap((results: ListaDatosCaPeriodoViewModel) => {
                    this.searching = true;
                    this.listaDatosCaPeriodo = results;
                    this.navMenuService.updateMenuServiceForPeriodo(this.periodoId);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.searching = false;
                    return of(null);
                }),
            )
            .subscribe();
    }

    onEdit(itemId: number | null): void {
        this.router.navigate([this.route + '/' + this.periodoId + '/edit', itemId]);
    }

    get formInvalid(): boolean {
        return this.listaDatosCaPeriodo == null || this.listaDatosCaPeriodo.DatosCaPeriodoCollection?.length === 0;
    }

    get esPeriodoFinalizado(): boolean {
        const hoy = new Date();
        if (this.listaDatosCaPeriodo?.PeriodoFechaFin) {
            return hoy >= new Date(this.listaDatosCaPeriodo.PeriodoFechaFin);
        } else {
            return false;
        }
    }
}
